@if (!editMode) {
  <div [innerHTML]="data"></div>
} @else {
  <mat-form-field class="example-full-width">
    <input matInput value="{{ data }}" />
  </mat-form-field>
}
